import SweetAlert from "@components/Feedback/SweetAlert/Index";

export default function ValidationsServico() {

    const validateFields = (fields) => {
        const {
            ano,
            servico,
            descricao,
        } = fields;
        const errors = {};

        if (!ano || isNaN(ano)) {
            errors.ano = "O campo Ano deve ser um número válido.";
        }
        if (!servico.trim()) errors.servico = "O campo Serviço é obrigatório.";
        if (!descricao.trim()) errors.descricao = "O campo Descrição é obrigatório.";

        return errors;
    };

    const warningMessage = async (flagAuditoria) => {
        const title = "Atenção!";

        let message = "";

        if (flagAuditoria === true) {
            message = `
                    <strong>Este serviço será cadastrado como <span style="color:#2b97be">Auditoria</span>.</strong><br><br>
                    Essa escolha irá impactar os <strong>status</strong> das solicitações relacionadas a este serviço no futuro.<br>
                    <br>
                    Tem certeza de que deseja continuar?
                `;
        } else {
            message = `
                    <strong>Este serviço será cadastrado como <span style="color:#d9534f">Não Auditoria</span>.</strong><br><br>
                    Essa escolha irá impactar os <strong>status</strong> das solicitações relacionadas a este serviço no futuro.<br>
                    <br>
                    Tem certeza de que deseja continuar?
                `;
        }

        return await SweetAlert.warningHTML(title, message);
    }

    return {
        validateFields,
        warningMessage
    }
}